import { render, staticRenderFns } from "./EditClosingUsulan.vue?vue&type=template&id=12ccfdaa&lang=pug&"
import script from "./EditClosingUsulan.vue?vue&type=script&lang=js&"
export * from "./EditClosingUsulan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports